export * from './file-data-my-suffix.service';
export * from './file-data-my-suffix-update.component';
export * from './file-data-my-suffix-delete-dialog.component';
export * from './file-data-my-suffix-detail.component';
export * from './file-data-my-suffix.component';
export * from './file-data-my-suffix.route';
